class SSEManager {
  constructor() {
    this.eventSource = null
    this.reconnectTimer = null
    this.reconnectAttempts = 0
    this.maxReconnectAttempts = 5
    this.reconnectDelay = 3000
    this.isConnecting = false
    this.isConnected = false
    this.url = ''
    this.onMessageCallback = null
    this.onErrorCallback = null
    this.onOpenCallback = null
    this.onCloseCallback = null
  }

  connect(url, options = {}) {
    if (this.isConnecting || this.isConnected) {
      console.warn('SSE: 连接已存在，请先断开')
      return
    }

    this.url = url
    this.isConnecting = true
    this.reconnectAttempts = 0

    const {
      onMessage,
      onError,
      onOpen,
      onClose,
      maxReconnectAttempts = 5,
      reconnectDelay = 3000,
      eventName = 'contractData'
    } = options

    this.onMessageCallback = onMessage
    this.onErrorCallback = onError
    this.onOpenCallback = onOpen
    this.onCloseCallback = onClose
    this.maxReconnectAttempts = maxReconnectAttempts
    this.reconnectDelay = reconnectDelay

    console.log('SSE: 准备连接', url)
    console.log('SSE: 监听事件名称', eventName)

    try {
      this.eventSource = new EventSource(url)
      console.log('SSE: EventSource 已创建', this.eventSource.readyState)

      this.eventSource.onopen = (event) => {
        console.log('SSE: 连接成功', event)
        this.isConnecting = false
        this.isConnected = true
        this.reconnectAttempts = 0
        if (this.onOpenCallback) {
          this.onOpenCallback(event)
        }
      }

      const handleMessage = (event) => {
        // console.log('SSE: 原始消息', event)
        // console.log('SSE: 消息数据', event.data)
        // console.log('SSE: 事件类型', event.type)

        try {
          const data = JSON.parse(event.data)
          // console.log('SSE: 解析后的数据', data)
          if (this.onMessageCallback) {
            this.onMessageCallback(data, event)
          }
        } catch (error) {
          console.warn('SSE: 消息解析失败，使用原始数据', error)
          if (this.onMessageCallback) {
            this.onMessageCallback(event.data, event)
          }
        }
      }

      this.eventSource.addEventListener(eventName, handleMessage)
      this.eventSource.onerror = (error) => {
        console.error('SSE: 连接错误', error)
        console.error('SSE: readyState', this.eventSource.readyState)
        this.isConnecting = false
        this.isConnected = false

        if (this.onErrorCallback) {
          this.onErrorCallback(error)
        }

        if (this.eventSource.readyState === EventSource.CLOSED) {
          this.handleReconnect()
        }
      }
    } catch (error) {
      console.error('SSE: 创建连接失败', error)
      this.isConnecting = false
      if (this.onErrorCallback) {
        this.onErrorCallback(error)
      }
      this.handleReconnect()
    }
  }

  handleReconnect() {
    if (this.reconnectAttempts >= this.maxReconnectAttempts) {
      console.error('SSE: 达到最大重连次数，停止重连')
      this.close()
      return
    }

    this.reconnectAttempts++
    console.log(`SSE: ${this.reconnectDelay / 1000}秒后尝试第 ${this.reconnectAttempts} 次重连...`)

    this.reconnectTimer = setTimeout(() => {
      this.connect(this.url, {
        onMessage: this.onMessageCallback,
        onError: this.onErrorCallback,
        onOpen: this.onOpenCallback,
        onClose: this.onCloseCallback,
        maxReconnectAttempts: this.maxReconnectAttempts,
        reconnectDelay: this.reconnectDelay
      })
    }, this.reconnectDelay)
  }

  close() {
    console.log('SSE: 关闭连接')
    this.isConnecting = false
    this.isConnected = false

    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer)
      this.reconnectTimer = null
    }

    if (this.eventSource) {
      this.eventSource.close()
      this.eventSource = null
    }

    if (this.onCloseCallback) {
      this.onCloseCallback()
    }

    this.resetCallbacks()
  }

  resetCallbacks() {
    this.onMessageCallback = null
    this.onErrorCallback = null
    this.onOpenCallback = null
    this.onCloseCallback = null
  }

  getStatus() {
    return {
      isConnecting: this.isConnecting,
      isConnected: this.isConnected,
      reconnectAttempts: this.reconnectAttempts
    }
  }
}

export default new SSEManager()